export const black = '#000000';
export const squidInk = '#232F3F';
export const gray900 = '#354152';
export const gray800 = '#495566';
export const gray700 = '#5C687C';
export const gray600 = '#6F7B8F';
export const gray500 = '#8290A4';
export const gray400 = '#A0AABA';
export const gray300 = '#B8BFCB';
export const gray200 = '#CED3DC';
export const gray100 = '#E6E9ED';
export const gray50 = '#F2F4F6';
export const gray25 = '#F8F9FA';
export const gray10 = '#FBFBFC';
export const white = '#FFFFFF';
export const inkwell = '#232F3F';
export const emperor = '#555555';
export const boulder = '#767676';
export const dustyGray = '#979797';
export const silver = '#BFBFBF';
export const alto = '#DDDDDD';
export const mercury = '#E7E7E7';
export const concrete = '#F3F3F3';
export const haze = '#F7F7F7';
export const alabaster = '#FBFBFB';
export const success = '#11883E';
export const orange600 = '#FF5A00';
export const blue900 = '#00508A';
